// src/i18n/index.js — i18next Konfiguration
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './de.json';
import en from './en.json';
import it from './it.json';
import cs from './cs.json';
import sk from './sk.json';
import fr from './fr.json';
import es from './es.json';
import hr from './hr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      it: { translation: it },
      cs: { translation: cs },
      sk: { translation: sk },
      fr: { translation: fr },
      es: { translation: es },
      hr: { translation: hr },
    },
    fallbackLng: 'de',
    // ⚠️ Eine Sprache muss an DREI Stellen stehen: import, resources und
    // supportedLngs. Fehlt sie hier, biegt i18next sie still auf die
    // Ersatzsprache um — die Uebersetzungen liegen dann ungenutzt im Buendel.
    //
    // Kroatisch deckt den oeffentlichen Teil ab (Startseite, Anmeldung,
    // Ergebnisse, Mattenaufruf). Die Turnierverwaltung faellt bewusst auf
    // Deutsch zurueck: so folgt sie kuenftigen Aenderungen automatisch,
    // statt auf dem heutigen Stand einzufrieren.
    supportedLngs: ['de', 'en', 'it', 'cs', 'sk', 'fr', 'es', 'hr'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'tda-lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
